<template>
    <div>

        <!-- Header -->
        <header-login />

        <!-- Main -->
        <main class="registerScreen">
            <div class="container-fluid">
                <div class="row --mainRow">
                    <!-- Left img -->
                    <div class="col-xs-12 col-md-4 col-lg-4 col-xl-6 d-none d-xl-block --loginBg leftCol" />

                    <div class="col-xs-12 col-md-12 col-lg-12 col-xl-6 rightCol">

                        <ol class="m-stepNavigation">
                            <li class="a-stepNavigation__item" :class="{'current': step === 'kolektiv', 'is-done': ['zoznam', 'zhrnutie', 'uspech'].includes(step) }">Informácie o kolektíve</li>
                            <li class="a-stepNavigation__item" :class="{'current': step === 'zoznam', 'is-done': ['zhrnutie', 'uspech'].includes(step)}">Zoznam žiakov</li>
                            <li class="a-stepNavigation__item" :class="{'current': step === 'zhrnutie', 'is-done': ['uspech'].includes(step)}">Zhrnutie</li>
                        </ol>

                        <register-kolektiv v-if="step === 'kolektiv'" :form="form" @updateStep="newStep => step = newStep" />
                        <register-zoznam v-if="step === 'zoznam'" :form="form" @updateStep="newStep => step = newStep" />
                        <register-zhrnutie v-if="step === 'zhrnutie'" :form="form" @updateStep="newStep => step = newStep" @submitForm="register">
                            <template v-slot:error-message>
                                <div v-if="responseText !== ''" :class="'alert alert-'+responseType" role="alert">
                                    <span :class="'icon --'+responseType"></span>{{ responseText }}
                                </div>
                            </template>
                        </register-zhrnutie>

                        <template v-if="step === 'uspech'">
                            <div class="paddingBox">
                                <p>
                                    Vaša registrácia bola úspešná.
                                    Teraz sa <router-link :to="{ name: 'login' }">môžete prihlásiť</router-link>.
                                </p>
                            </div>
                        </template>



                    </div>

                </div>
            </div>
        </main>
        <!-- .Main -->

    </div>
</template>



<script>
    import EventService from '@/services/EventService.js'
    import HeaderLogin  from './partials/HeaderLogin.vue'
    import RegisterKolektiv from "@/components/registracia/RegisterKolektiv.vue";
    import RegisterZoznam from "@/components/registracia/RegisterZoznam.vue";
    import RegisterZhrnutie from "@/components/registracia/RegisterZhrnutie.vue";

    export default {
        components: {
            RegisterZhrnutie,
            RegisterZoznam,
            RegisterKolektiv,
            HeaderLogin
        },
        mounted() {
            this.emitResetProfil()
        },
        computed: {},
        data() {
            return {
                step: 'kolektiv',

                form: {
                    pouzivatel_name: '',
                    pouzivatel_email: '',
                    pouzivatel_password: '',
                    pouzivatel_kraj: '',
                    pouzivatel_okres: '',
                    pouzivatel_obec: '',
                    pouzivatel_skola: '',
                    pouzivatel_rocnik: 1,
                    pouzivatel_ziaci: [],
                    pouzivatel_suhlas_pravidla_pouzivania: false,
                    pouzivatel_suhlas_osobne_udaje: false,
                    pouzivatel_suhlas_marketing: false,
                    pouzivatel_group: 1
                },

                responseType: '',
                responseText: '',
            }
        },
        methods: {
            // emit
            emitResetProfil() {
                this.$emit('resetProfil')
            },

            register() {
                EventService.register(this.form)
                    .then(response => {
                        this.responseType = response.data.code
                        this.responseText = response.data.data

                        if ( this.responseType === 'success' ) {
                            this.step = 'uspech'
                        }

                        this.$gtm.trackEvent({
                            event: 'Registration',
                            category: 'form',
                            action: 'submit',
                            label: 'registration',
                            value: 'successful',
                        });
                    })
                    .catch(error => {
                        this.responseType = 'warning'
                        this.responseText = error
                    })
            },
        }
    }
</script>
